 import axios from 'axios';

 //const API = axios.create({ baseURL: '/api',});


const API = axios.create({ baseURL: 'https://jsschooldb.yourcareconnect.online/api',});

//const API = axios.create({ baseURL: 'https://modernschoolcomplexdb.yourcareconnect.online/api',});

//const API = axios.create({ baseURL: 'https://wisdomdb.yourcaresystem.online/api',});


// Key under which the active school is remembered for super-users.
// Exported so AuthContext and the school switcher agree on one name.
export const ACTIVE_SCHOOL_KEY = 'active_school_id';

API.interceptors.request.use((config) => { 
  const token = localStorage.getItem('school_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;

  // Multi-school: tell the backend which school to serve.
  //
  // Only honoured for super-users (users whose school_id is NULL).
  // For everyone else the backend reads the school off the JWT and
  // ignores this header entirely, so a normal user cannot reach
  // another school's data by tampering with it — see
  // backend/middleware/tenantContext.js.
  const activeSchool = localStorage.getItem(ACTIVE_SCHOOL_KEY);
  if (activeSchool) config.headers['X-School-Id'] = activeSchool;

  return config;
});

API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('school_token');
      localStorage.removeItem('school_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default API;
